<template>
  <div v-if="currentEntity" class="col-md-12 no-padding sm-p-l-10 required accept-cgu text-center">
    <div class="checkbox">
      <input v-model="currentUser.acceptCGU"
              id="acceptCGU"
              name="acceptCGU"
              v-validate="'required'"
              type="checkbox" />
      <label for="acceptCGU">
        {{ $t("SignUpForm.accept") }}
        <a target="_blank" :href=externalLinks.termsOfService>
          {{ $t("SignUpForm.cgu_link") }}
        </a>
        <a v-if="hasPolicyUrl" class="usage-policy-url" target="_blank" :href=policyUrl>
            {{ $t("SignUpForm.usage_policy_url") }}
        </a>
      </label>
    </div>
    <transition name="slide-fade">
      <label v-show="errors.has('acceptCGU')"
              class="error text-center"
              for="acceptCGU">
        {{ errors.first('acceptCGU') }}
      </label>
    </transition>
  </div>
</template>

<script>
  import { externalLinks } from "../../settings/externalLinks";
  import ie_mixin from '@/mixin/ie'
  
  export default {
    name: "TermsAndConditions",
    mixins: [ie_mixin],
    inject: ['$validator'],
    props: ['currentUser', 'currentEntity'],
    data() {
      return {
        externalLinks: externalLinks
      }
    },
    computed: {
      hasPolicyUrl() {
        return this.currentEntity && this.policyUrl
      },
      policyUrl() {
        return this.currentEntity.usage_policy_url
      }
    }
  }
</script>

<style lang="scss" scoped>

  .accept-cgu {
    a {
      text-decoration: underline;
    }
    label::before {
      left: 2px;
    }
  }
  .usage-policy-url {
    font-weight: bold;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/candidate/TermsAndConditions.vue